import { Portal as PortalComponent } from '@marketmuse/components';

const Portal = props => <PortalComponent root="mms--portal-root" {...props} />;

export default Portal;
